import { Form } from 'common/components';
import { useProductDetail } from 'pages/product-full-view/components/product-new-detail-view/ProductDetailContext';
import {
  FormItemNumber,
  FormItemSelectEnum,
} from 'pages/product-full-view/shared/components';

export const FormItemGrain = (props) => {
  const { property } = props;

  const { formInstance } = useProductDetail();

  const slugValue = Form.useWatch('Slug', formInstance);

  if (slugValue === true) {
    return <FormItemNumber property={property} labelCol={{ span: 6 }} />;
  }

  return null;
};

export const FormItemBulletType = (props) => {
  const { property, propertyEnums, ...otherProps } = props;

  const { formInstance } = useProductDetail();

  const slugValue = Form.useWatch('Slug', formInstance);

  if (slugValue === true) {
    return (
      <FormItemSelectEnum
        property={property}
        nameFormItem={property.propertyName}
        propertyEnums={propertyEnums}
        {...otherProps}
      />
    );
  }
  return null;
};

export const FormItemShotSize = (props) => {
  const { property, propertyEnums, ...otherProps } = props;

  const { formInstance } = useProductDetail();

  const slugValue = Form.useWatch('Slug', formInstance);

  if (slugValue === false) {
    return (
      <FormItemSelectEnum
        property={property}
        nameFormItem={property.propertyName}
        propertyEnums={propertyEnums}
        {...otherProps}
      />
    );
  }
  return null;
};

export const FormItemShotWeight = (props) => {
  const { property } = props;

  const { formInstance } = useProductDetail();

  const slugValue = Form.useWatch('Slug', formInstance);

  if (slugValue === false) {
    return <FormItemNumber property={property} labelCol={{ span: 6 }} />;
  }

  return null;
};
